import React, { useState } from 'react';
import T from 'prop-types';

import Button from '../Button';

import { downloadBlobWorkaround } from '../../../utils/download-blob';

export const AsyncScreenshotButton = ({
  requestParams,
  defaultFilename = 'download.png',
  disabled,
  apiRequest,
  htmlApiRequest,
}) => {
  const [screenshotInProgress, setScreenshotInProgress] = useState(false);

  const downloadScreenshot = () => {
    setScreenshotInProgress(true);

    apiRequest(requestParams).then((response) => {
      const contentDisposition = response.headers['content-disposition'];
      let filename = defaultFilename;

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);

        if (filenameMatch.length > 1) {
          [, filename] = filenameMatch;
        }
      }
      downloadBlobWorkaround(response.data, filename);
      setScreenshotInProgress(false);
    });
  };

  // FOR DEBUG PURPOSES: open the live, JS-rendered HTML screenshot page in a new tab
  // instead of downloading the PNG. Same POST payload. The tab is opened
  // synchronously in the click handler (so pop-up blockers allow it) and the
  // HTML is written in once the response lands; the doc is same-origin, so its
  // pack/CSS load and React renders the chart.
  const openHtmlPreview = (previewWindow) => {
    setScreenshotInProgress(true);

    htmlApiRequest(requestParams).then((response) => {
      if (previewWindow) {
        previewWindow.document.open();
        previewWindow.document.write(response.data);
        previewWindow.document.close();
      }
      setScreenshotInProgress(false);
    });
  };

  const handleClick = (event) => {
    if (process.env.NODE_ENV === 'development' && htmlApiRequest && event.shiftKey) {
      openHtmlPreview(window.open('', '_blank'));
    } else {
      downloadScreenshot();
    }
  };

  return (
    <Button
      variant="secondary"
      shape="square"
      disabled={disabled}
      loading={screenshotInProgress}
      title={htmlApiRequest ? 'Screenshot (Shift+click to preview HTML)' : undefined}
      onClick={handleClick}
    >
      <i className="hicon-snapshot" />
    </Button>
  );
};

AsyncScreenshotButton.propTypes = {
  requestParams: T.object,
  defaultFilename: T.string,
  disabled: T.bool,
  apiRequest: T.func.isRequired,
  htmlApiRequest: T.func,
};
